export const STAGES = [
  { id: "scott", agents: ["scott"], name: "Mr Scott", role: "Scout" },
  { id: "jimmy", agents: ["jimmy"], name: "Mr Jimmy", role: "News · Catalyst" },
  { id: "funda", agents: ["funda"], name: "Mr Funda", role: "Fundamentals" },
  { id: "prakash", agents: ["prakash"], name: "Mr Prakash", role: "Technician" },
  { id: "crams", agents: ["crams"], name: "Mr Crams", role: "Validator" },
  { id: "debate", agents: ["london", "tariq"], name: "London vs Tariq", role: "Bull · Bear · Risk" },
  { id: "genie", agents: ["genie"], name: "Mr Genie", role: "Confirmer" },
];
const STAGE_OF = { scott: 0, jimmy: 1, funda: 2, prakash: 3, crams: 4, london: 5, tariq: 5, jimmycool: 5, genie: 6 };
export const stageOfAgent = (a) => STAGE_OF[a];

const ang = (i) => ((-90 + (i * 360) / STAGES.length) * Math.PI) / 180;
export const polar = (i, r, dDeg = 0) => {
  const a = ang(i) + (dDeg * Math.PI) / 180;
  return { x: 50 + r * Math.cos(a), y: 50 + r * Math.sin(a) };
};

export function deriveFlow(byAgent) {
  const t = {};
  const counts = Object.fromEntries(STAGES.map((s) => [s.id, { pass: new Set(), kill: new Set() }]));
  const get = (k, dir) => (t[k] = t[k] || { ticker: k, dir, stage: 0, order: Object.keys(t).length });
  const rows = (byAgent.scott || []).at(-1)?.payload?.rows || [];
  rows.forEach((r) => { const k = String(r.ticker).toUpperCase(); (r.kept ? counts.scott.pass : counts.scott.kill).add(k); });
  rows.slice(0, 10).forEach((r) => {
    const x = get(String(r.ticker).toUpperCase(), r.direction);
    if (!r.kept) { x.dead = true; x.killer = "Mr Scott"; x.stage = 0; }
  });
  Object.entries(byAgent).forEach(([ag, list]) => {
    const st = STAGE_OF[ag];
    if (!st) return;
    list.forEach((e) => {
      const p = e.payload || {};
      if (!p.ticker) return;
      const k = String(p.ticker).toUpperCase(), x = get(k, p.direction);
      x.stage = Math.max(x.stage, st);
      if (p.direction) x.dir = p.direction;
      if (ag === "prakash") Object.assign(x, { entry: p.entry, target: p.target, stop: p.stop });
      if (ag === "jimmycool" && p.confidence != null) x.conf = Number(p.confidence);
      if (ag === "genie") {
        if (p.verdict === "APPROVED") {
          x.approved = true; x.stage = 7;
          const m = /conf\s*([\d.]+)/i.exec(p.reason || "");
          if (x.conf == null && m) x.conf = Number(m[1]) <= 1 ? Number(m[1]) * 100 : Number(m[1]);
          counts.genie.pass.add(k);
        } else { x.dead = true; x.killer = "Mr Genie"; counts.genie.kill.add(k); }
      } else counts[STAGES[st].id].pass.add(k);
    });
  });
  const tally = Object.fromEntries(Object.entries(counts).map(([id, c]) => [id, { pass: c.pass.size, kill: c.kill.size }]));
  return { tokens: Object.values(t), tally };
}

export const usd = (v, hidden, dp = 2) => {
  if (hidden) return "•••••";
  if (v == null || Number.isNaN(Number(v))) return "—";
  const n = Number(v);
  return `${n < 0 ? "-" : ""}$${Math.abs(n).toLocaleString(undefined, { minimumFractionDigits: dp, maximumFractionDigits: dp })}`;
};
export const signed = (v, hidden) => (hidden ? "•••••" : v == null ? "—" : `${v >= 0 ? "+" : ""}${usd(v)}`);
export const px = (v) => {
  if (v == null || v === "") return "—";
  const n = Number(v);
  if (Number.isNaN(n)) return String(v);
  return n >= 1000 ? n.toLocaleString(undefined, { maximumFractionDigits: 2 }) : n >= 1 ? n.toFixed(2) : n.toPrecision(4);
};
export const tone = (v) => (v == null ? "" : v >= 0 ? "fc-gain" : "fc-loss");
export const firstLine = (s, max = 220) => {
  const t = String(s || "").replace(/\s+/g, " ").trim();
  const m = t.match(/^(.+?[.!?])(\s|$)/);
  const one = m ? m[1] : t;
  return one.length > max ? `${one.slice(0, max - 1)}…` : one;
};
export const maskText = (s, hidden) => (hidden ? String(s || "").replace(/[-+]?\$\s?[\d,]*\.?\d+\s?[kKmM]?/g, "•••").replace(/\$/g, "") : String(s || ""));
